export enum AnalyticsEvents {
  DEVICE_TOKEN_REGISTERED = "Device Token Registered",
  DEVICE_TOKEN_UNREGISTERED = "Device Token Unregistered",
  PUSH_NOTIFICATION_PERMISSIONS_DENIED = "Push Notification Permissions Denied",
  ADONIS_VIEWED = "AdonisViewed",
  ADONIS_LINK_CLICKED = "AdonisLinkClicked",
  GIFTCARD_SHARE_CLICKED = "GiftCardShareClicked",
}
